export function spaMetaHasRedisSnapshot(meta: Record<string, unknown>): boolean {
  const raw = meta.redis_status ?? meta.redisStatus;
  return (
    raw != null &&
    typeof raw === "object" &&
    !Array.isArray(raw) &&
    ("redis_enabled" in raw || "enable_diagnostics" in raw)
  );
}
